import React from 'react';

const HostExperience = () => {
    return (
        <>
            <h1>Host your Experience Page</h1>
        </>
    );
};

export default HostExperience;